import { NgModule } from "@angular/core";
import { AccordionPanelComponent } from "./accordion-panel.component";
import { AccordionModule } from "primeng/accordion";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [
        CommonModule,
        AccordionModule
    ],
    declarations: [
        AccordionPanelComponent
    ],
    exports: [
        AccordionPanelComponent
    ]
})
export class AccordionPanelModule { }